
import { getProjectList } from '@/api/project'

const contract = {
  state: {
    projectList: [], // 项目列表
    supplierList: []
  },
  getters: {
    // goodsTypeList: state => state.goodsTypeList,
    // receiveSendTypeList: state => state.receiveSendTypeList,
    // suppliesTypeList: state => state.suppliesTypeList,
  },
  mutations: {
    projectList: (state, projectList) => {
      state.projectList = projectList
    },
    supplierList: (state, supplierList) => {
      state.supplierList = supplierList
    }
  },
  actions: {
    handleProjectList (projectList, data) {
      getProjectList({ paging: false }).then(res => {
        if (res.status === 0) {
          projectList.commit('projectList', res.data)
        }
      })
    },
    handleSupplierList (supplierList, data) {
      supplierList.commit('supplierList', data)
    }
  }
}
export default contract
